export default __webpack_public_path__ + "static/media/clear.18d74b82.svg";